import { StateVariable } from '@akin-home/state-variables';

export const getAvatar = (variable?: StateVariable) => {
  if (!variable?.value) return;
  if (typeof variable.value !== 'string') return;

  return avatar_assets[variable.value];
};

const avatar_assets: { [key: string]: any } = {
  doctor_male: require('../assets/doctor_male.png'),
  doctor_female: require('../assets/doctor_female.png'),
};
